import React from 'react'
import { Card, Typography, Button, Result } from 'antd'
import { Icon } from 'xadmin-ui'
const { Paragraph, Text } = Typography;

const Error = ({ error, onClose }) => {
  return (
    <Card>
      <Result
        status="error"
        title="对不起，页面运行发生了错误！"
        subTitle="在页面运行中出现了错误，导致页面无法正常显示，这可能是系统配置不正确导致的，请联系您的系统管理员帮您解决."
        extra={[
          <Button type="primary" key="home" onClick={()=> window.location.href = window.location.origin+window.location.pathname}>
            回到首页
          </Button>,
          <Button key="refresh" onClick={()=> window.location.reload()}>刷新页面</Button>,
          <Button key="close" onClick={onClose}>关闭错误信息</Button>
        ]}
      >
        <div className="desc">
          <Paragraph>
            <Text
              strong
              style={{
                fontSize: 14,
              }}
            >
              如果您是开发人员，可查看如下错误详情:
            </Text>
          </Paragraph>
          <Paragraph>
            <Icon style={{ color: 'red' }} type="close-circle" />{' '}
            {error.toString()}
          </Paragraph>
        </div>
      </Result>
    </Card>
  )
}

export default Error